import { useMemo, FC } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, FormItem } from '@getsynapse/design-system';
import { selectProjectCategories } from 'state/Organization/organizationSlice';
import { ProjectCategory, Option } from 'utils/customTypes';
import intl from 'react-intl-universal';

interface ProjectCategoriesFilterProps {
  onSelect: (selected: string[]) => void;
  selected?: string[];
}

const ProjectCategoriesFilter: FC<ProjectCategoriesFilterProps> = ({
  onSelect,
  selected,
}) => {
  const categories = useSelector(selectProjectCategories);

  const options = useMemo(() => {
    return categories.map((category: ProjectCategory) => ({
      label: category.categoryName,
      value: category.id,
    }));
  }, [categories]);

  const selectedOptions = useMemo(() => {
    return options.filter((option: Option) => selected?.includes(option.value));
  }, [options, selected]);

  const handleSelect = (options: Option[]) => {
    const selectedIds = options.map((option) => option.value);
    onSelect(selectedIds);
  };

  return (
    <FormItem label={intl.get('PROJECT_DETAIL.CATEGORY')}>
      <Dropdown
        options={options}
        values={selectedOptions}
        onChange={handleSelect}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-categories-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectCategoriesFilter;
